module.exports = __webpack_public_path__ + "img/guarantee-platform.f22d2209.png";